import React from 'react';
import PropTypes from 'prop-types';
import { abbreviateNumber } from 'core-utilities';

function CardInfo({ game }) {
  const getVotePercentage = (upvotes, downvotes) => {
    let percentUp = 0;
    if (!Number.isNaN(upvotes) && !Number.isNaN(downvotes)) {
      if (upvotes === 0) {
        if (downvotes === 0) {
          return null;
        }
        percentUp = 0;
      } else if (downvotes === 0) {
        percentUp = 100;
      } else {
        percentUp = Math.floor((upvotes / (upvotes + downvotes)) * 100);
      }

      if (percentUp > 100) {
        percentUp = 100;
      }
    }
    return `${percentUp}%`;
  };

  const { totalUpVotes, totalDownVotes, playerCount } = game;
  const votePercentage = getVotePercentage(totalUpVotes, totalDownVotes);
  const displayPlayerCount = abbreviateNumber.getAbbreviatedValue(playerCount);
  return (
    <div className='game-card-info'>
      <span className='info-label icon-votes-gray' />
      {!votePercentage ? (
        <span className='info-label no-vote' />
      ) : (
        <span className='info-label vote-percentage-label'>{votePercentage}</span>
      )}
      <span className='info-label icon-playing-counts-gray' />
      <span className='info-label playing-counts-label' title={playerCount}>
        {displayPlayerCount}
      </span>
    </div>
  );
}

CardInfo.propTypes = {
  game: PropTypes.shape({
    universeId: PropTypes.number,
    playerCount: PropTypes.number,
    totalUpVotes: PropTypes.number,
    totalDownVotes: PropTypes.number
  }).isRequired
};

export default CardInfo;
